"use strict";

import angular from "angular";

import template from "./data-eva.component.html";
import "./themes/data-eva.component-dark.scss";
import "./themes/data-eva.component.scss";

import _ from "lodash";

import { Point } from "../../../gateway/Point/Point";
import { PointCalculated } from "../../../gateway/PointCalculated/PointCalculated";
import { Serie } from "../../../gateway/Serie/Serie";
import { CalculatingMachine } from "../../../presentation/services/CalculatingMachine/CalculatingMachine";
import { ColorService } from "../../../presentation/services/ColorService/ColorService";
import { DataManagerService } from "../../../presentation/services/DataManagerService";
import { SetSerieConstantUsecase } from "../../../usecases/set-serie-constant.usecase";

class DataEvaComponent {
    constructor($state, LoaderService, ThemesService, $scope) {
        this.$state = $state;
        this.ThemesService = ThemesService;
        this.$scope = $scope;
        this.Serie = new Serie();
        this.Point = new Point();
        this.PointCalculated = new PointCalculated();
        this.CalculatingMachine = new CalculatingMachine({
            Serie: this.Serie,
            Point: this.Point,
            PointCalculated: this.PointCalculated
        });
        this.DataManagerService = new DataManagerService();
        this.ColorService = new ColorService({ ThemesService: ThemesService });
        this.LoaderService = LoaderService;
        this.visualization = {};
        this.companyId = $state.params.id;
        this.loading = false;
    }

    $onInit() {
        this.CalculatingMachine.setSource(this.source);
        const structure = { chart: this.configs.chart };
        if (this.goals && this.visualizationData?.goals?.length) {
            structure.chart.goals = this.visualizationData?.goals.map((g) => {
                const color = this.ColorService.getLowerTonality(
                    structure?.chart?.series?.[0]?.color || "goals.medium"
                );
                return {
                    type: "line",
                    _id: g.r,
                    color: g.color || color,
                    dashStyle: g.dashStyle || "ShortDash"
                };
            });
        }
        this.visualization = structure;

        this._setRate();
    }

    async _setRate() {
        const params = {
            companyId: this.companyId,
            serieIds: ["tAnrDEqRR2hto1ev7"],
            scenario: _.get(this.$state, "params.scenario", "ORIGINAL"),
            period: "monthly",
            options: {
                recalculate: true
            }
        };

        const pointsResult = this.CalculatingMachine.result(params);
        const point = _.head(pointsResult);
        this.input = _.get(point, "m.c") || 0.1;
        this.oldInputValue = angular.copy(this.input);
        this.title = "Taxa de Retorno";
        this.buttonAlt = "ATUALIZAR " + "Taxa de Retorno";
    }

    async changeRate() {
        this.LoaderService.setProgress(true);
        if (this.oldInputValue == this.input) {
            this.LoaderService.setProgress(false);
            return;
        }
        const rateId = _.get(this.configs, "rate");
        this.oldInputValue = angular.copy(this.input);
        await new SetSerieConstantUsecase().execute({
            companyId: this.companyId,
            accountingId: this.$state.params.accountingId,
            base: {
                companyId: this.companyId,
                accountingId: this.$state.params.accountingId
            },
            value: this.input,
            scenarioId: this.$state?.params?.scenario || "ORIGINAL",
            rateId
        });
        this.loading = true;
        this.LoaderService.setProgress(false);
        this.$scope.$applyAsync();
        this.onRefreshData();
    }

    async onRefreshData() {
        const currentDate = {
            year: this.currentPeriod.date.getUTCFullYear(),
            month: this.currentPeriod.date.getUTCMonth() + 1
        };
        const currentComparation = {
            year: this.currentComparation.date.getUTCFullYear(),
            month: this.currentComparation.date.getUTCMonth() + 1
        };
        await this.DataManagerService.managerPointsCalc({
            company: this.companyData,
            source: "accounting",
            scenarioIdBase: this.currentPeriod.scenario._id,
            scenarioIdCompare: this.currentComparation.scenario._id,
            periodName: this.currentPeriod.period,
            analyzeGroup: _.get(this.currentFilterGroup, "value"),
            allMonths: this.currentComparation.allMonths,
            multipleSource: true,
            currentDate,
            currentComparation: this.currentComparation.active
                ? currentComparation
                : false
        });
        this.refreshData();
    }
}

DataEvaComponent.$inject = [
    "$state",
    "LoaderService",
    "ThemesService",
    "$scope"
];

const name = "evaIndicatorComponent";
const def = {
    bindings: {
        series: "<",
        configs: "<",
        points: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        refreshData: "&",
        currentFilterGroup: "<",
        companyData: "<",
        budget: "<",
        projection: "<",
        goals: "<",
        visualizationData: "<"
    },
    controller: DataEvaComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
